import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonService } from '../Model/Common/common.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserMasterService } from '../user-master.service';

@Component({
  selector: 'app-user-applicability-load',
  standalone: true,
  imports: [LoaderComponent, DataTablesModule, CommonModule, RouterModule],
  templateUrl: './user-applicability-load.component.html',
  styleUrl: './user-applicability-load.component.scss'
})
export class UserApplicabilityLoadComponent {

  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    public common: CommonService,
    private userMasterService: UserMasterService
  ) {
    this.dtoptions = { ...this.common.commonDToptions };  
  }

  ngOnInit(){
    this.GetApplicabilityAccess();
    this.common.CheckExpiry();
  }

  TableData = [] as any;

  GetApplicabilityAccess() {
    this.isDisabled = true;
    this.userMasterService.LoadApplicability({
      SelectType: 1,
      UserMasterID: 0,
    }).subscribe({
      next: (response) => {
        this.TableData = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicabilityName(id: any): string{
    if(id == 1){
      return 'Company';
    }else if (id == 2){
      return 'Branch';
    }else if (id == 3){
      return 'Client';
    }else if (id == 4){
      return 'Region';
    }else if (id == 5){
      return 'Zone';
    }else if (id == 6){
      return 'Industry Segment';
    }else{
      return 'Site'
    }
  }

}
